import { useState } from 'react';
import { Button } from '@mui/material';
import { Email, PhonelinkErase, Timer } from '@mui/icons-material';

const SendEmailButton = ({text, isErrorButton, startIcon, disabled, onClick}) => {
  const [sending, setSending] = useState(false);

  const handleClick = async () => {
    if (onClick !== undefined) {
      setSending(true);
      await onClick();
      setSending(false);
    }
  };

  if (startIcon === undefined) {
    startIcon = isErrorButton ? <PhonelinkErase /> : <Email />;
  }

  return (
    <Button
      sx={{ pt: 1, pb: 1 }}
      variant="contained"
      startIcon={startIcon}
      color={isErrorButton ? 'error' : 'primary'}
      onClick={handleClick}
      disabled={disabled || sending}
    >
      {text}
    </Button>
  );
};

export default SendEmailButton;